import Grid from '../components/grid'
import Container from '../components/ui/container'
import Text from '../components/ui/text'
import { Page } from '@telesoft/types/payload-types'
import React, { ReactElement } from 'react'

// TODO types

export type BlockProps = Extract<Page['blocks'][0], { blockType: 'dual-column-info' }>

export default function DualColumnInfo(block: BlockProps): ReactElement {
  const { one, two } = block
  return (
    <Container>
      <Grid>
        <div key={`column--key-${1}`} className="col-span-full md:col-span-4 lg:col-span-6 mt-4">
          <Text variant="body" className="whitespace-pre-wrap text-black">
            {one}
          </Text>
        </div>

        <div key={`column--key-${1}`} className="col-span-full md:col-span-4 lg:col-span-6 mt-4">
          <Text variant="body" className="whitespace-pre-wrap text-black">
            {two}
          </Text>
        </div>
      </Grid>
    </Container>
  )
}
